/**
 * Created by WorkAxis www.workaxis.in
 * Developer: Padma Dev.E
 * Developer Contact: padmadev.e@workaxis.in
 * Admin: shyam@workaxis.in
 * Date: 22/07/22
 * Time: 3:36 PM
 * Project: W-CRM
 */
import React, {useEffect, useRef, useState} from "react";
import "./style.css";
import Tooltip from "../Tooltip/Tooltip";
import Button from "../Button/Button";
import DotsVertical from "../../icon/DotsVertical";
import {getUUID} from "../../utils/util";

export default function MenuHolder({
                                       menuItems,
                                       isRes = true,
                                       isGrid = false,
                                       showTooltip = true
                                   }) {
    // Stable ids so menu tooltips aren't remounted every render (React <18 has no useId)
    const instanceId = useRef(getUUID()).current;
    const [menuOpen, setMenuOpen] = useState(false);
    const menuId = `menu-holder-${instanceId}`;
    useEffect(() => {
        const onClickOutside = (e) => {
            try {
                if (!document.getElementById(menuId).contains(e.target)) {
                    setMenuOpen(false);
                }
            } catch (err) {
            }
        };
        window.addEventListener("click", onClickOutside);
        return () => window.removeEventListener("click", onClickOutside);
    }, [menuId]);

    return (
        <>
            {isRes ? (
                <>
                    <div className={"menu-items-holder-big-screen"}>
                        {menuItems.map((item) => {
                            const showItem = item.isEnabled || item.disabledHint;
                            if (!showItem) return null;

                            return (
                                <Tooltip
                                    toolTip={showTooltip ? item.name : null}
                                    key={`menu-${item.name}-${instanceId}`}>
                                    <Button
                                        className="ml-05"
                                        type="link"
                                        size="large-square"
                                        disabled={item.isDisabled || !item.isEnabled}
                                        onClick={(event) => {
                                            if (!item.isEnabled) return;
                                            event.stopPropagation();
                                            item.action();
                                        }}
                                    >
                                        {item.icon}
                                    </Button>
                                </Tooltip>
                            );
                        })}
                    </div>

                    <div className={"menu-items-holder-mobile-screen"} id={menuId}>
                        <div className={"menu-items-holder-mobile-screen-hamburger"}>
                            <Button
                                className="ml-05"
                                type="link"
                                size="large-square"
                                onClick={(event) => {
                                    event.stopPropagation();
                                    setMenuOpen((old) => !old);
                                }}
                            >
                                <DotsVertical strokeWidth={2} className="w-2"/>
                            </Button>
                        </div>
                        <div
                            className={
                                "menu-items-holder-mobile-screen-list-holder shadow-wx-lg bg-white"
                            }
                        >
                            {menuOpen && (
                                <ul>
                                    {menuItems.map((item) => {
                                        const showItem = item.isEnabled || item.disabledHint;
                                        if (!showItem) return null;

                                        const isLocked = !item.isEnabled && item.disabledHint;

                                        return (
                                            <li
                                                className={
                                                    `menu-items-holder-mobile-screen-list-item-slot ${
                                                        isLocked || item.isDisabled
                                                            ? "disabled-calendar-action is-locked"
                                                            : ""
                                                    }`
                                                }
                                                key={`m-${item.name}-${instanceId}`}
                                                onClick={(event) => {
                                                    if (item.isEnabled && !item.isDisabled) {
                                                        event.stopPropagation();
                                                        item.action();
                                                    }
                                                }}
                                            >
                                                {item.icon}
                                                <span className="menu-item-label">{item.name}</span>
                                                {item.disabledHint && (
                                                    <span className="menu-item-upgrade-hint">
                                                        {item.disabledHint}
                                                    </span>
                                                )}
                                            </li>
                                        );
                                    })}
                                </ul>
                            )}
                        </div>
                    </div>
                </>
            ) : (
                <div className={"menu-items-holder-non-res"}>
                    {menuItems.map((item) => {
                        return (
                            <Tooltip
                                toolTip={showTooltip ? item.name : null}
                                key={`m-t-${item.name}-${instanceId}`}
                            >
                                <Button
                                    className="ml-05"
                                    type="link"
                                    size="large-square"
                                    disabled={item.isDisabled}
                                    onClick={(event) => {
                                        if (!item.isDisabled) {
                                            event.stopPropagation();
                                            item.action();
                                        }
                                    }}
                                >
                                    {item.icon}
                                </Button>
                            </Tooltip>
                        );
                    })}
                </div>
            )}
        </>
    );
}
